import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { FaXTwitter, FaLinkedin, FaTelegram, FaInstagram } from "react-icons/fa6";
import { API_URL } from '../config';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = async (e) => {
  e.preventDefault();
  if (!email) return;

  try {
    //const res = await fetch("http://localhost:8000/api/subscribe", 
    const res = await fetch(`${API_URL}/api/subscribe`,  {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (res.ok) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    } else {
      alert("Subscription failed. Try again.");
    }
  } catch (err) {
    console.error(err);
    alert("Server error.");
  }
};


  const quickLinks = [
    { name: 'Services', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  const socialLinks = [
  { name: 'Twitter', href: 'https://x.com/CleanTech_Inc', icon: <FaXTwitter /> },
  { name: 'LinkedIn', href: 'https://linkedin.com/company/cleantech', icon: <FaLinkedin /> },
  { name: 'Telegram', href: 'https://t.me/CleanTech_Support', icon: <FaTelegram /> },
  { name: 'Instagram', href: 'https://www.instagram.com/cleantech_solution_official/', icon: <FaInstagram /> }
];
  return (
    <footer className="bg-cleantech-charcoal-dark border-t border-white/10">
      {/* Newsletter Section */}
       <div className="section-container py-16">
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h3 className="text-3xl lg:text-4xl font-bold text-cleantech-white mb-4">
            Stay Updated with <span className="text-gradient">CleanTech</span>
          </h3>
          <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
            Get the latest insights on digital innovation, design trends, and exclusive offers directly to your inbox.
          </p>
          
          <form onSubmit={handleNewsletterSubmit} className="max-w-md mx-auto flex gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1"
              required
            /> <br/><br/>
            <button
              type="submit"
              className="btn-secondary whitespace-nowrap mx-auto flex"
              disabled={subscribed}
            >
              {subscribed ? '✓ Subscribed!' : 'Subscribe'}
            </button>
          </form>
        </motion.div> */}

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2 mb-6 flex flex-wrap justify-center gap-6 text-xl">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-lg lg:rounded-xl overflow-hidden shadow transition-all duration-300 hover:shadow-gold">
                <img
                src="/cleantech-logo.png"
                alt="Cleantech Logo"
                className="w-full h-full object-contain"
              />
              
              </div>
              <span className="text-2xl font-bold text-cleantech-white">
                Clean<span className="text-gradient">Tech</span>
              </span>
            </Link>
            
            <p className="text-white/80 mb-6 ">
              Premium software solutions crafted for the digital future. We create innovative websites, applications, and designs that elevate your brand to new heights.
            </p>
            
            <div className="space-y-2 text-white/70">
                  <p>
                    📧{" "}
                    <a href="mailto:nahomtemesgen77@gmail.com" className="hover:text-cleantech-gold transition-colors duration-300">
                      nahomtemesgen77@gmail.com
                    </a>
                  </p>
                  <p>
                    📞{" "}
                    <a href="tel:+251933181878" className="hover:text-cleantech-gold transition-colors duration-300">
                      +251-93-318-1878
                    </a>
                  </p>
                  {/* <p>
                    📍{" "}
                    <a
                      href="https://maps.app.goo.gl/XDBmWv6JjoyXVtVcA"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-cleantech-gold transition-colors duration-300"
                    >
                      Hawassa, Ethiopia
                    </a>
                  </p> */}
                </div>

          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold text-cleantech-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-white/70 hover:text-cleantech-gold transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <a href="#" className="text-white/70 hover:text-cleantech-gold transition-colors duration-300">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-xl font-semibold text-cleantech-white mb-6">Follow Us</h4>
            <div className="flex flex-wrap justify-center gap-6 text-xl">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  rel="noopener noreferrer"
                  className="w-12 h-12 text-white rounded-xl flex items-center justify-center text-xl hover:text-cleantech-gold transition-all duration-300 transform hover:scale-110"
                 
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            
            <div className="mt-8">
              <h5 className="text-lg font-medium text-cleantech-white mb-3">Legal</h5>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-white/70 hover:text-cleantech-gold transition-colors duration-300">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white/70 hover:text-cleantech-gold transition-colors duration-300">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-white/60">
            © 2025 CleanTech. All rights reserved. Crafted with ❤️ for digital excellence.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;